import { NavItem } from 'common/HorizontalNavPage';
import { useWorkersIntl } from './translations/useWorkersIntl';

export enum WORKERS_TABS {
  GENERAL = 'general'
}

export const useGetNavItems = () => {
  const intl = useWorkersIntl();

  const navItems: NavItem[] = [
    {
      label: intl.general,
      path: WORKERS_TABS.GENERAL,
      'data-test': 'workers-general',
      permissions: [{ name: 'SETTINGS_CONFIGURATION', action: 'READ' }]
    }
  ];

  return {
    navItems
  };
};
